import { TextProps } from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";

import { colors } from "#app/theme/v1/colors";
import { PartNameLabel } from "#modules/similarPart/view/PartNameLabel";
import { Icon } from "#shared/icons/Icon";
import { ActionIcon } from "#shared/view/components/ActionIcon";
import { CopyButton } from "#shared/view/components/CopyButton";
import { Group } from "#shared/view/components/Group";
import { File } from "shared";

import { DocumentsContainer } from "./DocumentsContainer";

type BaseProps = TextProps & {
  partName: string | undefined;
  files?: File[] | null;
};
type NonEditablePartNameProps = BaseProps & {
  partId?: string;
  editable?: false;
};
type EditablePartNameProps = BaseProps & {
  partId: string;
  editable: true;
};

type PartNameProps = NonEditablePartNameProps | EditablePartNameProps;

export const PartName = ({
  partName,
  partId,
  files,
  style,
  editable = false,
  ...props
}: PartNameProps) => {
  if (!partName) {
    return null;
  }

  return (
    // oxlint-disable-next-line typescript/no-misused-spread
    <Group gap={0} wrap="nowrap" style={{ width: "100%", ...style }}>
      <PartNameLabel partName={partName} editable={editable} partId={partId} {...props} />

      <CopyButton value={partName}>
        {({ copied, copy }) => (
          <ActionIcon
            color={copied ? colors.green[5] : colors.grey?.[3]}
            variant="subtle"
            onClick={(e) => {
              e.stopPropagation();
              copy();
            }}
          >
            {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
          </ActionIcon>
        )}
      </CopyButton>

      {files && (
        <DocumentsContainer files={files}>
          <ActionIcon
            color={colors.grey?.[3]}
            variant="subtle"
            onClick={(e) => e.stopPropagation()}
          >
            <Icon name="file" color={colors.gray[3]} />
          </ActionIcon>
        </DocumentsContainer>
      )}
    </Group>
  );
};
